import { Badge, Button, Card, Col } from "react-bootstrap";
import SvgUser from "components/svg/SvgUser";
import { useTranslation } from "react-i18next";
import { DateTime as DT } from "luxon";
import vconst from "utils/helpers/structs/vconst";
import ObjectStatusIcon from "../../ObjectsList/ObjectStatus/ObjectStatusIcon";
import { useStatusObject } from 'modules/objects';
import * as apiObject from "api/apiObject4Team";
import { useRef, useState } from "react";
import SpinnerBlock from "components/others/SpinnerBlock";
import SolarIcon from 'components/icons/SolarIcon';
 
const ObjectItem = ({vobject, setClientInfoId, fetchObjects, setShowObject}) => {

    const { t } = useTranslation(['Objects']);
    const [ showSpinner, setShowSpinner ] = useState(false);
    const { statusObjectInWork, statusObjectFinishedTeam } = useStatusObject();
    const refBtnClient = useRef();
    const dt = DT.fromMillis(vobject?.objectDeadline||0).toLocaleString(DT.DATE_MED);
    const dtClassName = (DT.now().toMillis() > vobject?.objectDeadline) ? 'text-danger' : 'text-body';

    const handleInWork = async ({status}) => {
        setShowSpinner(true);
        
        const resInWork = status ==  vconst.objectInWork
                ? await apiObject.takeInWorkObject(vobject.ID)
                : await apiObject.finishedTeamObject(vobject.ID);

        await fetchObjects(false);
        setShowSpinner(false)
    }
 
    const handleFilnishedTeam = async (objectId) => {
        console.log('finished team', objectId);
    }    

    return (
        <Col xs={12}>
        <Card className="ticket-card" 
            style={{ 
                scrollMarginTop:'130px',
                borderLeft:`3px solid var(--bs-${vobject.objectStatus == vconst.objectInWork ? 'success' : 'warning'})`
            }}> 
            <SpinnerBlock show={showSpinner}/>
            <Card.Body className="p-3">
                <div className="d-flex justify-content-between border-bottom pb-2 mb-2">
                    <div>
                        <h6 className="mb-1 cursor-pointer text-break">{vobject.clientName}</h6>
                        <p className="text-muted f-12 mb-0 my-1">{vobject.clientPhone}</p> 
                    </div>
                    <div>
                    <Button className="fs-14 ms-1 px-1 py-0"
                        ref={refBtnClient}
                        variant="light-primary"
                        size="sm"
                        title={t('Leads:leadPopup.client')}
                        onClick={(e)=>{
                            setClientInfoId(vobject?.clientId||null)
                            refBtnClient.current?.blur();
                        }}>
                        <SvgUser/>
                    </Button>
                    </div>
                </div>


                {vobject.objectInfo && (<>
                    <div className="h5 mt-3 fs-12 font-bold text-uppercase text-muted">
                        {t('labelInfo')}
                    </div>
                    <div className="help-md-hidden ">
                        <div className="bg-body mb-3 p-3 rounded event-info">
                            <p className="mb-0" dangerouslySetInnerHTML={{__html:vobject.objectInfo}}>
                            </p>
                        </div>
                    </div></>)}

                <div className="d-md-flex justify-content-between">

                    <div  className="me-1 d-flex align-items-center">
                         
                        <span className="me-2"><ObjectStatusIcon status={vobject.objectStatus}/></span>
                        {vobject.objectStatus == vconst.objectPanding 
                            ? (<span className={`fw-medium ${dtClassName}`}>{dt}</span>)
                                
                            : (<><Badge bg="success">{t('status.1')}</Badge></>)}
                        
                    </div> 
                    <div className="mt-3 mt-md-0 text-end">
                        {vobject.objectStatus == vconst.objectPanding &&
                        (<Button
                            variant="success"
                            size="sm"
                            onClick={()=>statusObjectInWork(handleInWork)}>
                                <SolarIcon name="play-fill" className="fs-14 me-1" />
                                {t('btnInWork')}</Button>)}

                        {vobject.objectStatus == vconst.objectInWork &&
                        (<Button
                            variant="primary"
                            size="sm"
                            onClick={()=>setShowObject(vobject.ID)}>
                                <SolarIcon name="pencil-square" className="fs-14 me-1" />
                                {t('btnOpen')}</Button>)} 

                        {vobject.objectStatus !== vconst.objectPanding && 
                        (<Button className="ms-1"
                            variant="success"
                            size="sm"
                            onClick={()=>statusObjectFinishedTeam(handleInWork)}>
                                <SolarIcon name="sunrise" className="fs-14 me-1" />
                                {t('btnFinishedTeam')}</Button>)}                                                               
                    </div>
                </div>
                
            </Card.Body>
            
        </Card>
        </Col>
    )
}

export default ObjectItem; 